import { render, screen } from '@testing-library/react'
import InterventionAxes from './InterventionAxes'

describe('InterventionAxes links', () => {
  test('education axis links to the education page', () => {
    render(<InterventionAxes />)

    const educationLink = screen.getAllByRole('link', { name: /ver más/i })[0]

    expect(educationLink.getAttribute('href')).toBe('/educacion')
  })

  test('research axis links to the research page', () => {
    render(<InterventionAxes />)

    const hrefs = screen.getAllByRole('link', { name: /ver más/i }).map((link) => link.getAttribute('href'))

    expect(hrefs).toContain('/investigacion')
  })

  test('activism axis links to the activism page', () => {
    render(<InterventionAxes />)

    const hrefs = screen.getAllByRole('link', { name: /ver más/i }).map((link) => link.getAttribute('href'))

    expect(hrefs).toContain('/activismo')
  })

  test('red axis links to the new red page', () => {
    render(<InterventionAxes />)

    const hrefs = screen.getAllByRole('link', { name: /ver más/i }).map((link) => link.getAttribute('href'))

    expect(hrefs).toContain('/red')
    expect(hrefs).not.toContain('/memorias')
  })
})
